// @flow
import * as React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  width: 100%;
  height: 100%;
  padding: 0 ${({ theme }) => theme.metrics.smallMargin}px;

  background-color: ${({ theme }) => theme.colors.cardBackground};
  box-shadow: ${({ theme }) => theme.colors.boxShadow};
`;

const Content = styled.div`
  height:100%;
`;

const Title = styled.h1`
  margin: ${({ theme }) => theme.metrics.margin}px;
  margin-bottom: ${({ theme }) => theme.metrics.smallMargin}px;

  color: ${({ theme }) => theme.fonts.style.smallCardTitle.color};
  font-size: ${({ theme }) => theme.fonts.style.smallCardTitle.fontSize}px;
  font-family: ${({ theme }) => theme.fonts.style.smallCardTitle.fontFamily}px;
`;

type Props = {
  title?: string,
  children: any,
}

export default function SCard(props: Props) {
  const { title, children } = props;
  return (
    <Wrapper>
      {title && <Title>{title}</Title>}
      <Content>
        {children}
      </Content>
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/common/components/cards/SCard.js